import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"
import _imports_0 from '@/assets/images/admin-img/light_delete-outline.svg'


const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "admin-mid-container" }
const _hoisted_3 = {
  class: "admin-custom-row admin-page-row",
  id: "leftMenuSlideBox"
}
const _hoisted_4 = { class: "admin-right-sidebar" }
const _hoisted_5 = { class: "admin-right-sidebar-in" }
const _hoisted_6 = { class: "admin-right-sidebar-in-top" }
const _hoisted_7 = { class: "admin-custom-row" }
const _hoisted_8 = { class: "admin-right-sidebar-in-top-left" }
const _hoisted_9 = { class: "admin-right-sidebar-in-top-right" }
const _hoisted_10 = { class: "admin-search-box" }
const _hoisted_11 = {
  key: 0,
  class: "admin-right-sidebar-in-top-right-btm"
}
const _hoisted_12 = { class: "tags" }
const _hoisted_13 = { class: "delete-all-btn-link" }
const _hoisted_14 = {
  key: 0,
  class: "admin-item-list-section admin-contact-section"
}
const _hoisted_15 = {
  class: "admin-item-list-section-in",
  ref: "scrollWrapper",
  "data-simplebar": ""
}
const _hoisted_16 = { class: "admin-item-list-section-scroll" }
const _hoisted_17 = { class: "admin-item-list-top" }
const _hoisted_18 = { class: "admin-item-list-row" }
const _hoisted_19 = { class: "admin-item-checkbox" }
const _hoisted_20 = { class: "admin-checkbox-input" }
const _hoisted_21 = ["checked"]
const _hoisted_22 = { class: "admin-item-sm-actions" }
const _hoisted_23 = { class: "admin-item-list-btm" }
const _hoisted_24 = { ref: "sortableList" }
const _hoisted_25 = { class: "admin-item-box-top" }
const _hoisted_26 = { class: "admin-item-list-row" }
const _hoisted_27 = { class: "admin-item-checkbox" }
const _hoisted_28 = { class: "admin-checkbox-input" }
const _hoisted_29 = ["id", "onChange", "checked"]
const _hoisted_30 = ["for"]
const _hoisted_31 = { class: "admin-item-contact-name text-limit" }
const _hoisted_32 = { class: "admin-item-contact-email" }
const _hoisted_33 = { class: "admin-item-contact-subject text-limit" }
const _hoisted_34 = { class: "admin-item-contact-message text-limit" }
const _hoisted_35 = { class: "admin-item-sm-actions" }
const _hoisted_36 = { class: "admin-action-link" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 0,
  class: "admin-item-box-btm admin-contact-btn-row"
}
const _hoisted_40 = { class: "admin-contact-details" }
const _hoisted_41 = { class: "custom-row" }
const _hoisted_42 = { class: "admin-contact-details-left" }
const _hoisted_43 = { class: "admin-contact-box" }
const _hoisted_44 = { class: "admin-contact-box" }
const _hoisted_45 = { class: "admin-contact-box" }
const _hoisted_46 = { class: "admin-contact-details-right" }
const _hoisted_47 = { class: "admin-contact-box" }
const _hoisted_48 = { class: "btn-set-left-align" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = {
  id: "closeBtn",
  class: "admin-btn-link-primary addNewCancel"
}
const _hoisted_51 = { class: "admin-pagination-section" }
const _hoisted_52 = { class: "custom-row" }
const _hoisted_53 = { class: "item-show-selectbox" }
const _hoisted_54 = {
  key: 0,
  class: "admin-pagination",
  id: "paginationBox"
}
const _hoisted_55 = ["onClick"]
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { class: "admin-site-footer" }
const _hoisted_58 = { class: "container" }
const _hoisted_59 = {
  class: "modal fade confirmation-popup",
  id: "deletePop",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static"
}
const _hoisted_60 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_61 = { class: "modal-content" }
const _hoisted_62 = { class: "confirmation-popup-mid" }
const _hoisted_63 = { class: "confirmation-popup-btm" }
const _hoisted_64 = {
  id: "popNoBtn",
  class: "admin-btn-outline-secondary",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_adminHeader = _resolveComponent("adminHeader")!
  const _component_adminNavigation = _resolveComponent("adminNavigation")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_adminHeader),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_adminNavigation),
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.constants.MANAGE_CONTACT_US_TEXT) + " (" + _toDisplayString(_ctx.counts) + ") ", 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _withDirectives(_createElementVNode("input", {
                      id: "seachContactInput",
                      type: "text",
                      placeholder: "Search",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchedText) = $event)),
                      onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.fetchContacts(_ctx.status,_ctx.limit,_ctx.skip), _ctx.fetchCounts(_ctx.searchedText)), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.searchedText]
                    ])
                  ]),
                  (_ctx.selectedContacts.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", null, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.selectedContacts.length) + " entries selected", 1),
                              _createElementVNode("button", {
                                id: "tagCloseBtn",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedContacts = [], _ctx.selectAll = false))
                              })
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("button", {
                            class: "btn_link",
                            id: "deleteAllBtn",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#deletePop",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setDeleteMode('all')))
                          }, _toDisplayString(_ctx.constants.DELETE_ALL_BUTTON), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (_ctx.contacts.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("input", {
                                name: "cssCheckbox",
                                id: "selectAll",
                                type: "checkbox",
                                class: "css-checkbox",
                                onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args))),
                                checked: _ctx.selectAll === true
                              }, null, 40, _hoisted_21),
                              _cache[14] || (_cache[14] = _createElementVNode("label", { for: "selectAll" }, null, -1))
                            ])
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-contact-name",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleSort('name'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.NAME_LABEL) + " ", 1),
                            (_ctx.sortBy === 'name' || _ctx.sortBy === '-name')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-name' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-contact-email",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleSort('email'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.EMAIL_LABEL) + " ", 1),
                            (_ctx.sortBy === 'email' || _ctx.sortBy === '-email')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-email' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-contact-subject",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toggleSort('subject'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.SUBJECT_LABEL) + " ", 1),
                            (_ctx.sortBy === 'subject' || _ctx.sortBy === '-subject')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-subject' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-contact-message",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toggleSort('message'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.MESSAGE_LABEL) + " ", 1),
                            (_ctx.sortBy === 'message' || _ctx.sortBy === '-message')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-message' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.constants.ACTIONS_LABEL), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contacts, (contact, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: contact.id,
                              class: _normalizeClass(['admin-item-box', { 'show-edit-item': contact.editing }])
                            }, [
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, [
                                      _createElementVNode("input", {
                                        name: "cssCheckbox",
                                        id: 'demo_opt_' + contact.id,
                                        type: "checkbox",
                                        class: "css-checkbox",
                                        onChange: ($event: any) => (_ctx.toggleContactSelection(contact.id)),
                                        checked: _ctx.selectedContacts.includes(contact.id)
                                      }, null, 40, _hoisted_29),
                                      _createElementVNode("label", {
                                        for: 'demo_opt_' + contact.id
                                      }, null, 8, _hoisted_30)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_31, _toDisplayString(contact.name), 1),
                                  _createElementVNode("div", _hoisted_32, _toDisplayString(contact.email), 1),
                                  _createElementVNode("div", _hoisted_33, _toDisplayString(contact.subject), 1),
                                  _createElementVNode("div", _hoisted_34, _toDisplayString(contact.message), 1),
                                  _createElementVNode("div", _hoisted_35, [
                                    _createElementVNode("ul", _hoisted_36, [
                                      _createElementVNode("li", null, [
                                        _createElementVNode("button", {
                                          id: "contactPgEditBtn",
                                          class: "editBtn",
                                          onClick: ($event: any) => (_ctx.editContact(index))
                                        }, "View", 8, _hoisted_37)
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createElementVNode("button", {
                                          id: "contactPgDeleteBtn",
                                          class: "hide-row-btn",
                                          "data-bs-toggle": "modal",
                                          "data-bs-target": "#deletePop",
                                          onClick: ($event: any) => (_ctx.setDeleteMode('single', contact.id))
                                        }, _toDisplayString(_ctx.constants.DELETE_BUTTON), 9, _hoisted_38)
                                      ])
                                    ])
                                  ])
                                ])
                              ]),
                              (contact.editing)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                    _createElementVNode("div", _hoisted_40, [
                                      _createElementVNode("div", _hoisted_41, [
                                        _createElementVNode("div", _hoisted_42, [
                                          _createElementVNode("div", _hoisted_43, [
                                            _createElementVNode("label", null, _toDisplayString(_ctx.constants.NAME_LABEL), 1),
                                            _createElementVNode("p", null, _toDisplayString(contact.name), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_44, [
                                            _createElementVNode("label", null, _toDisplayString(_ctx.constants.EMAIL_LABEL), 1),
                                            _createElementVNode("p", null, _toDisplayString(contact.email), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_45, [
                                            _createElementVNode("label", null, _toDisplayString(_ctx.constants.SUBJECT_LABEL), 1),
                                            _createElementVNode("p", null, _toDisplayString(contact.subject), 1)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_46, [
                                          _createElementVNode("div", _hoisted_47, [
                                            _createElementVNode("label", null, _toDisplayString(_ctx.constants.MESSAGE_LABEL), 1),
                                            _createElementVNode("p", null, _toDisplayString(contact.message), 1)
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_48, [
                                        _createElementVNode("button", {
                                          id: "deleteBtn",
                                          class: "admin-btn-link-primary",
                                          "data-bs-toggle": "modal",
                                          "data-bs-target": "#deletePop",
                                          onClick: ($event: any) => (_ctx.setDeleteMode('single', contact.id))
                                        }, _toDisplayString(_ctx.constants.DELETE_BUTTON), 9, _hoisted_49),
                                        _createElementVNode("button", _hoisted_50, _toDisplayString(_ctx.constants.CLOSE_BUTTON), 1)
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2))
                          }), 128))
                        ], 512)
                      ])
                    ])
                  ], 512),
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _withDirectives(_createElementVNode("select", {
                          id: "paginationSelectBox",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.limit) = $event)),
                          onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleLimitChange && _ctx.handleLimitChange(...args)))
                        }, [...(_cache[15] || (_cache[15] = [
                          _createElementVNode("option", { value: "10" }, "10", -1),
                          _createElementVNode("option", { value: "20" }, "20", -1),
                          _createElementVNode("option", { value: "50" }, "50", -1),
                          _createElementVNode("option", { value: "100" }, "100", -1)
                        ]))], 544), [
                          [_vModelSelect, _ctx.limit]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.ENTRIES_PER_PAGE_LABEL), 1)
                      ]),
                      (_ctx.totalPages > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                            _createElementVNode("ul", null, [
                              (_ctx.currentPage !== 1)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 0,
                                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changePage(_ctx.currentPage - 1)))
                                  }, [...(_cache[16] || (_cache[16] = [
                                    _createElementVNode("a", {
                                      href: "#",
                                      class: "pagination-previous"
                                    }, null, -1)
                                  ]))]))
                                : _createCommentVNode("", true),
                              (_ctx.totalPages != 1)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.visiblePages, (page) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: page,
                                      onClick: ($event: any) => (_ctx.changePage(page))
                                    }, [
                                      _createElementVNode("a", {
                                        href: "#",
                                        class: _normalizeClass({ active: _ctx.currentPage === page })
                                      }, _toDisplayString(page), 3)
                                    ], 8, _hoisted_55))
                                  }), 128))
                                : _createCommentVNode("", true),
                              (_ctx.currentPage !== _ctx.totalPages)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 2,
                                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.changePage(_ctx.currentPage + 1)))
                                  }, [...(_cache[17] || (_cache[17] = [
                                    _createElementVNode("a", {
                                      href: "#",
                                      class: "pagination-next"
                                    }, null, -1)
                                  ]))]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_56, [...(_cache[18] || (_cache[18] = [
                  _createElementVNode("p", null, "No data to display", -1)
                ]))]))
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_57, [
      _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.constants.COPYRIGHT_TEXT), 1)
    ]),
    _createElementVNode("div", _hoisted_59, [
      _createElementVNode("div", _hoisted_60, [
        _createElementVNode("div", _hoisted_61, [
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "confirmation-popup-icon" }, [
            _createElementVNode("i", null, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("p", null, _toDisplayString(_ctx.constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT), 1)
          ]),
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("button", _hoisted_64, _toDisplayString(_ctx.constants.NO_BUTTON), 1),
            _createElementVNode("button", {
              id: "popYesBtn",
              class: "admin-btn-outline-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
            }, _toDisplayString(_ctx.constants.YES_BUTTON), 1)
          ])
        ])
      ])
    ])
  ]))
}